<app-header 
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>
<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'about.title' | translate}}
  </div>
  <div class="about">
    <div class="about-section" [innerHTML]="'about.intro' | translate"></div>
    <div class="about-section" [innerHTML]="'about.purpose' | translate"></div>
    <div class="about-section" [innerHTML]="'about.features' | translate"></div>
    <div class="about-section" [innerHTML]="'about.data' | translate"></div>
    <div class="about-section" [innerHTML]="'about.audience' | translate"></div>
    <div class="about-section" [innerHTML]="'about.mission' | translate"></div>
    <div class="about-section" [innerHTML]="'about.contact' | translate"></div>
  </div>
</div>